import { getScript } from 'js/utils/scripts.util';
import { useCallback } from 'react';

export const useDownloadOobeeSDK = ({ mobileClientURL }) => {
    return useCallback(async () => {
        if (!window.GCOobee) {
            await getScript(mobileClientURL);
        }

        return window.GCOobee.createClient();
    }, [mobileClientURL]);
};
